import { render, staticRenderFns } from "./pulsemedia.vue?vue&type=template&id=496a770f&scoped=true&v-once=true"
import script from "./pulsemedia.vue?vue&type=script&lang=js"
export * from "./pulsemedia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496a770f",
  null
  
)

export default component.exports